export const getUserAccountInfo = async(setUserAccountInfo) => {
    var endpoint = '/user/download/account.json';
    try{
       const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
        method: 'GET',
        credentials: 'include'
       });
       res.json().then((res) => {
        setUserAccountInfo(res.data)
       });
       if(!res.ok){
        throw new Error(`Error ${res.status} ${res.statusText}`)
       }
    }catch (err){

    }
}